import { NavigateNextRounded, HomeRounded } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';

// Route name map for pretty labels
const routeLabels = {
  '': 'Home',
  'accounts': 'Loan Accounts',
  'customers': 'Customers',
  'dashboard': 'Dashboard',
  'profile': 'Profile',
  'support': 'Support',
  'subscription': 'Subscription',
  'addCustomer': 'Add Customer',
  'account': 'Account'
};

function AppBreadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  // Don't show breadcrumbs on home
  if (segments.length === 0) return null;

  const crumbs = [
    { label: 'Home', to: '/' },
    ...segments.map((seg, i) => {
      const to = '/' + segments.slice(0, i + 1).join('/');
      // Shorten IDs (compound keys like "ABC123_DEF456") to first part
      const isId = seg.includes('_') || seg.length > 16;
      const label = isId
        ? seg.split('_')[0].toUpperCase()
        : (routeLabels[seg] || seg.charAt(0).toUpperCase() + seg.slice(1));
      return { label, to };
    }),
  ];

  return (
    <nav aria-label="breadcrumb" style={{
      display: 'flex', alignItems: 'center', gap: 4,
      padding: '6px 20px',
      borderBottom: '1px solid var(--border-subtle)',
      background: 'var(--bg-primary)',
      fontSize: 12,
      color: 'var(--text-muted)',
      flexShrink: 0,
      minHeight: 32,
    }}>
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span key={crumb.to} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            {i === 0 ? (
              <HomeRounded style={{ fontSize: 14, color: 'var(--text-muted)', marginRight: 2 }} />
            ) : (
              <NavigateNextRounded style={{ fontSize: 14, color: 'var(--text-muted)' }} />
            )}
            {isLast ? (
              <span style={{ color: 'var(--text-primary)', fontWeight: 600 }}>{crumb.label}</span>
            ) : (
              <Link to={crumb.to} style={{ color: 'var(--text-muted)', textDecoration: 'none' }}
                onMouseEnter={e => e.target.style.color = 'var(--accent-green)'}
                onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}
              >
                {crumb.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}

export default AppBreadcrumbs;
